/* eslint-disable @typescript-eslint/no-non-null-assertion,@typescript-eslint/consistent-type-assertions */
import { Note } from "@octopusdeploy/design-system-components";
import { DebouncedTextWithLabel as DebounceText, DeprecatedSelect } from "@octopusdeploy/design-system-octopus-components";
import { ControlType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { dropdownOptionsValidator } from "~/components/form";
interface ControlTypeSelectorProps {
    controlType: ControlType | undefined;
    selectOptions: string | undefined;
    includedControlTypeOptions?: ControlType[];
    excludedControlTypeOptions?: ControlType[];
    onControlTypeChange(controlType: ControlType): void;
    onSelectOptionsChange(selectOptions: string): void;
    controlTypeError?: string;
    selectOptionsError?: string;
    hideDescription?: boolean;
    disableSelect?: boolean;
}
export const controlTypeItemData = [
    { value: ControlType.SingleLineText, text: "Single-line text box" },
    { value: ControlType.MultiLineText, text: "Multi-line text box" },
    { value: ControlType.Select, text: "Drop down" },
    { value: ControlType.Checkbox, text: "Checkbox" },
    { value: ControlType.Sensitive, text: "Sensitive/password box" },
    { value: ControlType.Package, text: "Package" },
    { value: ControlType.StepName, text: "A previous deployment step name" },
    { value: ControlType.AzureAccount, text: "Azure Account" },
    { value: ControlType.AmazonWebServicesAccount, text: "AWS Account" },
    { value: ControlType.GoogleCloudAccount, text: "Google Cloud Account" },
    { value: ControlType.GenericOidcAccount, text: "Generic Oidc Account" },
    { value: ControlType.UsernamePasswordAccount, text: "Username Password Account" },
    { value: ControlType.Certificate, text: "Certificate" },
    { value: ControlType.WorkerPool, text: "Worker Pool" },
    { value: ControlType.TargetTags, text: "Target Tags" },
    { value: ControlType.Feed, text: "Container Feed" },
    { value: ControlType.Environments, text: "Environments" },
    { value: ControlType.TenantTags, text: "Tenant Tags" },
    { value: ControlType.Teams, text: "Teams" },
    { value: ControlType.Channels, text: "Channels" },
    { value: ControlType.Project, text: "Project" },
];
export const controlTypeValueToTextMap: Map<ControlType, string> = new Map(controlTypeItemData.map((item) => [item.value, item.text]));
export default class ControlTypeSelector extends React.Component<ControlTypeSelectorProps> {
    render() {
        return (<div>
                <DeprecatedSelect disabled={this.props.disableSelect} label="Control type" value={this.props.controlType} items={this.controlTypeItems()} onChange={(x) => this.props.onControlTypeChange(ControlType[x as keyof typeof ControlType])} error={this.props.controlTypeError}/>
                {!this.props.hideDescription && <Note>The type of control to display.</Note>}

                {this.props.controlType === ControlType.Select && (<div>
                        <DebounceText multiline={true} minRows={4} label="Drop down options" value={this.props.selectOptions!} validate={dropdownOptionsValidator()} onChange={(x) => this.props.onSelectOptionsChange(x)} error={this.props.selectOptionsError}/>
                        <Note>
                            <div>
                                Enter each option on a new line. Use | to separate values and display text - e.g.:
                                <pre>
                                    Value1|Display text 1
                                    <br />
                                    Value2|Display text 2
                                </pre>
                            </div>
                        </Note>
                    </div>)}
            </div>);
    }
    private controlTypeItems() {
        return controlTypeItemData.filter((x) => {
            if (this.props.includedControlTypeOptions) {
                return this.props.includedControlTypeOptions.indexOf(x.value) !== -1;
            }
            if (this.props.excludedControlTypeOptions) {
                return this.props.excludedControlTypeOptions.indexOf(x.value) === -1;
            }
        });
    }
    static displayName = "ControlTypeSelector";
}
